import dayjs from "dayjs";
import { TFunction } from "i18next";
import { formatLocaleDate } from "../../../common/utils/formatUtils";
import { CommissionKind } from "../batch/enums";
import { getCommissionKindCategory } from "../batch/utils";
import { CreateUpdateProductCommissionsSettings } from "./types";

export const getProductCommissionsSettingsLabel = (
  commission: Pick<CreateUpdateProductCommissionsSettings, "startDate" | "endDate">,
  t: TFunction,
) => {
  const valueFrom = `${t("common.from")}: ${commission.startDate ? `${formatLocaleDate(dayjs(commission.startDate))}` : "-"}`;
  const valueTo = `${commission.endDate ? `${t("common.to")}: ${formatLocaleDate(dayjs(commission.endDate))}` : ""}`;

  return `${valueFrom} ${valueFrom.length > 1 && valueTo.length ? "-" : ""} ${valueTo}`;
};

export const getCommissionKindTabLabel = (commissionKind: CommissionKind, t: TFunction) =>
  `${t(`commissions.batch.enums.commissionKind.${commissionKind}`)} (${t(`commissions.productCommissionsSettings.helpers.commissionKindShort.${getCommissionKindCategory(commissionKind)}`)})`;
